import React, { FC } from "react";
import { CalendarContext, useCalendar } from "../../context/calendar";

const CalendarProvider: FC = ( props:any ) => {
  const context = useCalendar();
  return (
    <CalendarContext.Provider value={context}>
      {props.children}
    </CalendarContext.Provider>
  );
};

export default CalendarProvider;
